module.exports = __webpack_public_path__ + "static/media/x.ec123fb9.svg";